
export const loadImgData = async (src) => {
    const img = await new Promise<any>((resolve) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = () => {
            resolve(img);
        };
        img.src = src;
    });

    const c = document.createElement("canvas");

    c.width  = img.naturalWidth;
    c.height = img.naturalHeight;

    const ctx = c.getContext("2d", { willReadFrequently: true });
    ctx.drawImage(img, 0, 0);

    return {
        canvas: c,
        imgData: ctx.getImageData(0, 0, c.width, c.height),
    };
};
